import { makeVar } from '@apollo/client';

import { CvTerms } from './models/cv.models';

export const setRegStep = makeVar<number>(0);
export const setCvTerms = makeVar<CvTerms>({
  points: 0,
  fromDays: 0,
  toDays: 0,
  startDate: '',
  endDate: '',
});
